<h1 mat-dialog-title>{{ data.title }}</h1>

<mat-dialog-content>
  <div [innerHTML]="data.message" class="mb-3">

  </div>

  <div class="row mb-1" *ngIf="!noDocs">
    <ng-container>
      <div class="text-wrapper ml-3">
        {{ 'properties.structures.textConfimFormRemakeNoDocs' | translate }}
      </div>
    </ng-container>
  </div> <!-- ./row -->

  <div class="mb-1" *ngIf="noDocs">
    <table class="table table-borderless">
      <thead>
        <th>{{ 'properties.documentsPage.docType' | translate }}</th>
        <th>{{ 'properties.documentsPage.descr' | translate }}</th>
        <th>{{ 'properties.documentsPage.date' | translate }}</th>
        <th></th>
      </thead>
      <tbody>
        <tr *ngFor="let item of docs">
          <td>
            <mat-checkbox [(ngModel)]="item.value" class="checkbox-insert">
              {{ item.title }}
            </mat-checkbox>
          </td>
          <td>{{ item.content }}</td>
          <td>{{ item.docDate | date}}</td>
          <td>
            <a mat-button *ngIf="item.document
              && item.document.length"
            (click)="onToggleDownloadDocument(item.document)"
            mat-raised-button mat-default color="primary">
              <mat-icon fontSet="fal" fontIcon="fa-download" class="icon-action">
              </mat-icon>
              {{ 'common.cta.download' | translate }}
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div> <!-- ./row -->
</mat-dialog-content>

<div mat-dialog-actions class="mt-5">
  <div class="row w-100">
    <div class="col-6 text-left">
      <a mat-button (click)="onDenial()" mat-raised-button mat-default color="warn">
        {{ data.btnCancelText }}
      </a>
    </div> <!-- /.col -->
    <div class="col-6 text-right">
      <a mat-button (click)="onConfirmation()" mat-raised-button mat-default color="primary">
        {{ data.btnOkText }}
      </a>
    </div> <!-- /.col -->
  </div> <!-- /.row -->
</div>